<style lang="scss" scoped>
img {
    height: 100%;
    width: 100%;
    object-fit: contain;
}
img.rounded {
    border-radius: 24px;
}
</style>

<template>
    <img v-if="image" :data-src="image.url" :alt="image.alt" class="lazyload" :class="{ rounded: rounded }" />
</template>

<script>
export default {
    props: {
        image: {
            required: true,
            default: () => ({
                url: "",
                alt: ""
            })
        },
        rounded: {
            type: Boolean,
            default: false
        }
    }
};
</script>
